import { createAction } from '@reduxjs/toolkit';
import type { PopulatedExport } from '@/services/api/exports';
import type { SerializedExport } from '@enmon/commons/lib/enmon';
import type { AnyAction } from 'redux';
import {
  CREATE_EXPORT_ERROR,
  CREATE_EXPORT_SUCCESS,
  EDIT_EXPORT_ERROR,
  EDIT_EXPORT_SUCCESS,
  DELETE_EXPORT_ERROR,
  DELETE_EXPORT_SUCCESS,
  TOGGLE_ACTIVE_EXPORT_ERROR,
  TOGGLE_ACTIVE_EXPORT_SUCCESS,
  EXPORT_DATA_READY,
  FORCE_RUN_EXPORT_SUCCESS,
  FORCE_RUN_EXPORT_ERROR,
} from './constants';

export function createExportSuccess() {
  return {
    type: CREATE_EXPORT_SUCCESS,
  };
}
createExportSuccess.type = CREATE_EXPORT_SUCCESS;

export function createExportError() {
  return {
    type: CREATE_EXPORT_ERROR,
  };
}

export function exportDataReady(payload: SerializedExport) {
  return {
    type: EXPORT_DATA_READY,
    payload,
  };
}
exportDataReady.type = EXPORT_DATA_READY;

export interface ExportDataReadyAction {
  type: typeof EXPORT_DATA_READY;
  payload: {
    _id: string;
    name: string;
    id: string;
  };
}

// Type guard function
export const isExportDataReadyAction = (action: AnyAction): action is ExportDataReadyAction => {
  return action.type === EXPORT_DATA_READY;
};

export const editExportSuccessAction = createAction(EDIT_EXPORT_SUCCESS);
export const editExportErrorAction = createAction(EDIT_EXPORT_ERROR);

export const toggleActiveExportSuccessAction = createAction(
  TOGGLE_ACTIVE_EXPORT_SUCCESS,
  ({ active, name }: Pick<PopulatedExport, 'active' | 'name'>) => ({ payload: { active, name } }),
);
export const toggleActiveExportErrorAction = createAction(
  TOGGLE_ACTIVE_EXPORT_ERROR,
  ({ active, name }: Pick<PopulatedExport, 'active' | 'name'>) => ({ payload: { active, name } }),
);

export const deleteExportSuccessAction = createAction(DELETE_EXPORT_SUCCESS);
export const deleteExportErrorAction = createAction(DELETE_EXPORT_ERROR);

export const forceRunExportSuccessAction = createAction(FORCE_RUN_EXPORT_SUCCESS);
export const forceRunExportErrorAction = createAction(FORCE_RUN_EXPORT_ERROR);
